import React from 'react';

const MyPlanErrorState = ({ onRetry }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-16 px-4 text-center text-content">
    <p>No se pudo cargar tu plan, inténtalo de nuevo</p>
    <button
      type="button"
      onClick={onRetry}
      className="px-4 py-2 rounded-md bg-amber hover:bg-amber-hover text-on-amber text-sm font-medium transition-colors"
    >
      Reintentar
    </button>
  </div>
);

export default MyPlanErrorState;
